import Translation from "src/translations/locales/translation";

import { Component, ReactNode } from "react";
import { withTranslation } from "react-i18next";
import { WithTFunction } from "src/types/WithTFunction";

import {
  UpdatePasswordScreenResetedProps,
  UpdatePasswordScreenResetedState,
} from "./index.interfaces";

class UpdatePasswordScreenReseted extends Component<
  WithTFunction<UpdatePasswordScreenResetedProps>,
  UpdatePasswordScreenResetedState
> {
  render(): ReactNode {
    const { t } = this.props;

    return (
      <section className="flex flex-col gap-8 desktop:gap-20 w-full max-w-[400px] py-16 tablet:py-28 desktop:py-0 desktop:min-w-[60vw] desktop:px-[12.5%]">
        {/* title */}
        <h1 className="text-lg font-new-atten-bold text-center">
          {t(Translation.screens.updatePassword.reseted.title).toUpperCase()}
        </h1>
      </section>
    );
  }
}

export default withTranslation()(UpdatePasswordScreenReseted);
